function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.166 4.894v2.151H1.635V4.894m6.501-1.003L4.401.724.665 3.891",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "inherit",
  strokeLinecap: "round",
  strokeMiterlimit: 10
});

function SvgSlimAaronsHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.801 7.769"
  }, props), _ref);
}

export default SvgSlimAaronsHome;